import { useEffect } from 'react';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const useSetPageLoadingWhenRequesting = (id: string, loadingArray: boolean[]) => {
  const { actions: pageActions } = usePageContext();
  const { getTextIdTranslation } = useTranslation();

  const isAnyRequestOngoing = () => {
    for (const loading of loadingArray as boolean[]) {
      return loading;
    }
    return false;
  };
  const pageNeedsLoading = isAnyRequestOngoing();

  const setLoadingIfRequesting = () => {
    pageActions.setLoading(pageNeedsLoading, getTextIdTranslation(id) !== '' ? getTextIdTranslation(id) : id);
  };

  useEffect(() => {
    setLoadingIfRequesting();
  }, [pageNeedsLoading]);
};
